/* jshint esversion: 6 */
import utils from "../libs/utils";
import { findListing } from "@/libs/api";
const group = "search";

const model = {
	HISTORY_KEYWORDS_LIST: [], // 历史搜索
	SEARCH_LIST: [], // 搜索结果
};

export const types = utils.genTypes(model, group);
export const state = utils.genState(model, group);
export const getters = utils.genGetters(types);
export const mutations = utils.genMutations(types);

mutations[types.RESET] = (s) => {
	Object.keys(s).forEach((key) => {
		s[key] = state[key];
	});
};

export const actions = {
	// 存入历史搜索关键字
	[types.HISTORY_KEYWORDS_LIST](store, keyword) {
		let historyList = JSON.parse(JSON.stringify(store.getters[types.HISTORY_KEYWORDS_LIST]));
		if (historyList.length === 0) {
			historyList.push(keyword);
		} else {
			let num = 0;
			historyList.forEach((item) => {
				if (item === keyword) {
					num++;
				}
			});
			if (num === 0) {
				historyList.push(keyword);
			}
		}
		store.commit(types.HISTORY_KEYWORDS_LIST, historyList);
	},
	// 搜索结果
	[types.SEARCH_LIST](store, query) {
		return findListing(query).then((res) => {
			if (res.returnCode === "0000") {
				res.data.Listings.forEach((item) => {
					item.price = item.price.toFixed(2);
				});
			} else {
				res.data.Listings = [];
			}
			return res;
		});
	},
};
